import { render, staticRenderFns } from "./CommercialPaper.vue?vue&type=template&id=8b68a652&scoped=true"
import script from "./CommercialPaper.vue?vue&type=script&lang=js"
export * from "./CommercialPaper.vue?vue&type=script&lang=js"
import style0 from "./CommercialPaper.vue?vue&type=style&index=0&id=8b68a652&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b68a652",
  null
  
)

export default component.exports